@if (calculationModuleService.isOnlyCMInputs$()) {
  <button matButton="outlined" (click)="hiddenInput.click()">Import file</button>
  <input hidden type="file" accept=",.csv" #hiddenInput (change)="importAndApply($event)" />
  <span>
    If you used the "export indicator" function after running the CM, you may now upload the
    obtained .csv file to reuse the same inputs.
  </span>
} @else {
  <div>Inputs import is not available on CM using dynamic inputs</div>
}
